module.exports = __webpack_public_path__ + "static/MobileImage3-ff2b11149319064e3e5e400c4d8d41fe.png";